let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e6o61")).then(() => parcelRequire('9bBMV'));